import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Loading from 'components/LoadingComponent';
import SwipeableCards from 'components/Steps/SwipeableCards';
import { getRecommendedUsers } from 'modules/users/actions';
import NoUserInfoImg from 'assets/images/think/no_think_chats.svg';
import { LoadingWrapper, FeedbackWrapper, NoElements } from './styles';

const MAX_USERS = 10;

function RecommendationUsers(props) {
  const {
    app, resetAll, setBreadcrumb, literals,
    getSerendipityAction, history,
  } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [recommendedUsersIds, setRecommendedUsersIds] = useState([]);
  const [isTheEnd, setIsTheEnd] = useState(false);

  const initBreadcrumb = () => {
    const breadcrumb = [
      {
        type: 'back',
      },
      {
        color: '#ffffff',
        text: literals.serendipity,
      },
    ];

    setBreadcrumb(breadcrumb.slice());
  };

  const loadRecommendations = () => {
    getRecommendedUsers()
      .then((response) => {
        setIsLoading(false);
        setRecommendedUsersIds(response.ids);

        if (!response.ids.length) {
          const action = getSerendipityAction();
          if (action) {
            action();
          } else {
            history.push('/no-recommendations');
          }
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const handleEnd = () => {
    setIsTheEnd(true);
  };

  useEffect(() => {
    initBreadcrumb();
    resetAll();
    loadRecommendations();
  }, []);

  if (isLoading) {
    return (
      <LoadingWrapper>
        <Loading colorAnimation={app.color1} />
      </LoadingWrapper>
    );
  }

  if (isTheEnd || !recommendedUsersIds.length) {
    return (
      <FeedbackWrapper>
        <div className='title' dangerouslySetInnerHTML={{ __html: literals.descriptionUsers }} />
        <NoElements>
          <div className='nocontent'>
            <img src={NoUserInfoImg} alt='' />
            <div className='text'>{literals.noUsers}</div>
          </div>
        </NoElements>
      </FeedbackWrapper>
    );
  }

  return (
    <div>
      <FeedbackWrapper>
        <div className='title' dangerouslySetInnerHTML={{ __html: literals.descriptionUsers }} />
        <SwipeableCards
          users={recommendedUsersIds.slice(0, MAX_USERS)}
          hideFirst
          onEnd={handleEnd}
        />
      </FeedbackWrapper>
    </div>
  );
}

RecommendationUsers.propTypes = {
  app: PropTypes.object.isRequired,
  literals: PropTypes.object.isRequired,
  resetAll: PropTypes.func.isRequired,
  setBreadcrumb: PropTypes.func.isRequired,
  getSerendipityAction: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

export default RecommendationUsers;



// WEBPACK FOOTER //
// ./src/routes/RecommendationsUsers/components/index.jsx